import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getThousandsFormats} from 'src/openapi/admin/apis/GetThousandsFormatsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectThousandFormats} from './services/dictionary-slice';

export const useThousandFormats = () => {
    const apiDispatch = useAppDispatch();
    const thousandFormats = useSelector(selectThousandFormats);

    const loadThousandFormats = useCallback(() => {
        if (!thousandFormats.length) {
            apiDispatch(getThousandsFormats());
        }
    }, [thousandFormats.length, apiDispatch]);

    return {thousandFormats, loadThousandFormats};
};
